import { c as _c } from "react/compiler-runtime";
import { Image } from '@/product-discovery/components/Image/Image';
import Illustration from './Illustration.svg';
type StoresEmptyStateProps = {
  heading: string;
  description: string;
};
export function StoresEmptyState(t0) {
  const $ = _c(8);
  const {
    heading,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Image className="mx-auto mb-4" src={Illustration.src} width={Illustration.width} height={Illustration.height} isLcp={false} alt="" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== heading) {
    t2 = <h2 className="ut-headline-sm">{heading}</h2>;
    $[1] = heading;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== description) {
    t3 = <p className="text-secondary ut-body-fixed-md text-pretty">{description}</p>;
    $[3] = description;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div className="p-8 text-center max-sm:px-4">{t1}{t2}{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}